import Grid from "@material-ui/core/Grid";
import WarningIcon from "@material-ui/icons/Warning";
import Typography from "@material-ui/core/Typography";
import {ValidationRow} from "../../_shared/wizard/ValidationRow";
import UserAvatar from "../../user-avatar/UserAvatar";
import {Machine} from "../../../models/machine.models";
import React, {Fragment} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import {FormStatus} from "../../../models/shared";
import {AddMachineForm, MachineToAddModel} from "../../../models/membership.models";

const useStyles = makeStyles((theme) => ({
    itemContainer:{
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1)
    },
    errorBanner: {
        width: '100%',
        backgroundColor: theme.palette.error.main,
        color: theme.palette.error.contrastText
    },
    formsContainer: {
        marginTop: theme.spacing(2)
    },
    avatarColumn: {
        maxWidth: 70,
        width: 70
    }
}));

const AddMachinesValidation = (props: {forms: AddMachineForm[], setForms: (arg0: (prevForms: AddMachineForm[]) => AddMachineForm[]) => void, setMachineEmails: (arg0: (prev: MachineToAddModel[]) => MachineToAddModel[]) => void, setSelectedMachines: (arg0: (prev: Machine[]) => Machine[]) => void}) => {
    const classes = useStyles();
    const {t} = useTranslation();

    const failedCount = props.forms.filter(f => f.status === FormStatus.failed).length;

    const onRemoved = (id: number | string) => {
        props.setForms((prevForms) => prevForms.filter(f => f.id !== id));
        if (typeof id === "number") {
            props.setMachineEmails(prev => prev.filter(f => f.id !== id));
        } else {
            props.setSelectedMachines(prev => prev.filter(f => f.id !== id));
        }
    };

    return <Fragment>
        {
            failedCount > 0 &&
            <Grid container className={classes.errorBanner} justify='center'>
                <WarningIcon/>
                <Typography variant="body2">
                    {t('Subscription.SubscriptionAssignment.XEntriesNeedAttention', {failedCount})}
                </Typography>
            </Grid>
        }
        <Grid container className={classes.formsContainer}>
            {
                props.forms
                    .map((f) =>
                        <ValidationRow processingStatus={f.status}
                                       handleDeleteItem={() => onRemoved(f.id)}
                                       errorMessage={f.errorMessage ? f.errorMessage : '_Common.Api.Messages.FailedToAddContact'}>
                            <Grid container item xs={11} spacing={4} className={classes.itemContainer}>
                                <Grid item className={classes.avatarColumn}>
                                    <UserAvatar userId={typeof f.id === "number" ? undefined : f.id} key={f.id}/>
                                </Grid>
                                <Grid item>
                                    <Typography variant="body1" color={'textPrimary'}>{(f.data as Machine)?.friendlyName || ""}</Typography>
                                    <Typography variant="body2" color={'textPrimary'}>{f.data.email}</Typography>
                                </Grid>
                            </Grid>
                        </ValidationRow>
                    )
            }
        </Grid>
    </Fragment>
};

export default AddMachinesValidation;
